<template>
  <c-search-form :input-search-items="searchItems"
                 :form-name="formName"
                 :hiddenFields="hiddenFields"
                 model="searchForm" :fields="fields"
                 key-property="logId"
                 :search-url="searchUrl"
                 :accept-create="false"
                 :accept-delete="false"
  >
  </c-search-form>
</template>

<script>
import axios from "axios";
import CSearchForm from "../../../components/form/ManageForm";

export default {
  name: 'log-management',
  components: {CSearchForm},
  data: () => {
    return {
      formName: "Lấy ngày vip Tiếng anh và Toán",
      searchUrl: null,
      searchItems: [
        {
          type: "text",
          name: "userId",
          label: "Nhập userId",
          placeHolder: "",
          focus: true
        },
      ],
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'daysVip',
          text: 'Ngày vip tiếng anh',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'daysVipMath',
          text: 'Ngày vip toán',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },

      ]
    }
  },
  methods: {

  },
  created() {
    this.searchUrl ="/kidOrderMath/searchUserId";
  }

}
</script>
